import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { logout } from "../../api/api";
import { sessionVariables } from "../util/constants";

const Sidebar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLogout = async (e) => {
    e.preventDefault();
    try {
      await logout(JSON.parse(sessionStorage.getItem("accessToken")));
    } catch (error) {
      console.error(error);
    }
    Object.values(sessionVariables).forEach(v => {
      sessionStorage.removeItem(v);
    });
    window.location.reload();
  };

  return (
    <div className="flex flex-col fixed top-0 left-0 h-full w-16 bg-gray-100 shadow-lg z-40">
      {/* Top Section */}
      <div className="flex flex-col items-center py-3 space-y-3">
        {/* Logo */}
        <div className="w-8 h-8 bg-red-500 rounded-full flex items-center justify-center text-white font-bold text-sm">
          *
        </div>
        {/* User Avatar */}
        <img src="#" alt="User Avatar" className="w-8 h-8 rounded-full" />
      </div>

      {/* Navigation Section */}
      <div className="flex flex-col items-center mt-4 space-y-4">
        <NavLink to="/dashboard" className="relative group">
          <button className="text-gray-600 hover:text-teal-500" title="Dashboard">
            <i className="fa fa-home text-xl"></i>
          </button>
        </NavLink>

        <NavLink to="/my-tickets" className="relative group">
          <button className="text-gray-600 hover:text-teal-500" title="My Tickets">
            <i className="fa-solid fa-list-ol text-xl"></i>
          </button>
        </NavLink>

        <NavLink to="/assigned-tickets" className="relative group">
          <button className="text-gray-600 hover:text-teal-500" title="Assigned Tickets">
            <i className="fa-solid fa-th-list text-xl"></i>
          </button>
        </NavLink>

        {/* Search Icon */}
        <NavLink to="/cliente-dashboard" className="relative group">
          <button className="text-gray-600 hover:text-teal-500">
            <i className="fa fa-search text-xl"></i>
          </button>
        </NavLink>
        <NavLink to="/settings" className="relative group">
          <button className="text-gray-600 hover:text-teal-500" title="Settings">
            <i className="fa fa-cogs text-xl"></i>
          </button>
        </NavLink>
        <NavLink to="/settings/ticket-heads" className="relative group">
          <button className="text-gray-600 hover:text-teal-500" title="Ticket Heads">
            <i className="fa fa-cog text-xl"></i>
          </button>
        </NavLink>

        {/* Notifications Icon */}
        <button className="text-gray-600 hover:text-teal-500">
          <i className="fa fa-bell text-xl relative">
            <span className="absolute top-0 right-0 h-2 w-2 bg-red-500 rounded-full"></span>
          </i>
        </button>
      </div>

      {/* Divider */}
      <hr className="my-4 border-gray-300 w-8 mx-auto" />

      {/* Spaces Section */}
      <div className="flex flex-col items-center space-y-3">
        <div className="w-3 h-3 rounded-full bg-teal-500"></div>
        <div className="w-3 h-3 rounded-full bg-blue-500"></div>
        <div className="w-3 h-3 rounded-full bg-purple-500"></div>
      </div>
      <hr className="my-4 border-gray-300 w-8 mx-auto" />
      {/* Spaces Section */}
      <div className="flex flex-col items-center space-y-3">
        <NavLink to="/ajustes" className="relative group">
          <button className="text-gray-600 hover:text-teal-500" title="Settings">
            <i className="fa fa-cog text-xl"></i>
          </button>
        </NavLink>
        <NavLink to="/admin/report-settings" className="relative group">
          <button className="text-gray-600 hover:text-teal-500" title="Report Settings">
            <i className="fa-duotone fa-solid fa-toolbox text-xl"></i>
          </button>
        </NavLink>
        <NavLink to="/report/entries" className="relative group">
          <button className="text-gray-600 hover:text-teal-500" title="Entries Report">
            <i className="fa-duotone fa-solid fa-list text-xl"></i>
          </button>
        </NavLink>
        <NavLink to="/report/ticket-summary-report" className="relative group">
          <button className="text-gray-600 hover:text-teal-500" title="Ticket Category Summary">
            <i className="fa-duotone fa-solid fa-chart-bar text-xl"></i>
          </button>
        </NavLink>
      </div>

      {/* Divider */}
      <hr className="my-4 border-gray-300 w-8 mx-auto" />

      {/* Bottom Section */}
      <div className="flex flex-col items-center mt-auto mb-3 space-y-4">
        {/* Logout Button */}
        <button
          className="text-gray-600 hover:text-teal-500"
          onClick={handleLogout}
        >
          <i className="fa fa-power-off text-xl"></i>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
